var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBlockingSpinner)?_c('div',{staticClass:"blocking-spinner"},[_c('div',{staticClass:"spinner"},[_c('b-spinner',{attrs:{"label":"Spinning","variant":"light"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }